// extracted by mini-css-extract-plugin
export default {"left-hand-card-image":"IpaAdministrationDetailViewLeftHandCard_left-hand-card-image__R3Wrk"};